import {NewsDynamic} from "../src/news/components/NewsDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

const config = [{reactDynamic: "news-cars", view: <NewsDynamic />}];

(() => prepareHydratedApp(config))();
